import React from "react";
import ReactDOM from "react-dom";
import "semantic-ui-css/semantic.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import "./App.css";

ReactDOM.render(<App />, document.getElementById("root"));
